'use client';

import { SearchDrawer } from '@eliadmin/core/src/components/header/search-bar/search-drawer';
import { useMobileSearch } from '@eliadmin/core/src/components/header/mobile-search';
import { useRef } from 'react';
import type { ButtonProps } from '@eliadmin/core/src/components/ui/button';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { IoIosSearch } from 'react-icons/io';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

// Brand-specific trigger only. Dialog, queries, pricing and result rendering live in core.
export type SearchButtonProps = Omit<ButtonProps, 'onClick' | 'className'> & {
  className?: {
    root?: string;
    icon?: string;
  };
  whiteText: boolean;
};

export function SearchButton(props: SearchButtonProps) {
  const { className, whiteText, ...buttonProps } = props;
  const { t } = useTranslations();
  const sharedOpen = useMobileSearch((s) => s.isOpen);
  const toggle = useMobileSearch((s) => s.toggle);
  const sharedOpenRef = useRef(sharedOpen);
  sharedOpenRef.current = sharedOpen;
  const notifyOpen = (next: boolean) => {
    if (sharedOpenRef.current === next) return;
    sharedOpenRef.current = next;
    toggle();
  };
  return (
    <SearchDrawer
      onOpenChange={notifyOpen}
      trigger={
        <Button
          type="button"
          {...buttonProps}
          className={cn('ea-search-button', className?.root)}
          variant={'none'}
          size="none"
          aria-label={t('text1')}
        >
          <IoIosSearch
            aria-hidden
            size={24}
            className={cn(whiteText ? 'text-white' : 'text-[#251D17]', className?.icon)}
          />
        </Button>
      }
    />
  );
}
